import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { useLanguage } from '../contexts/LanguageContext';

/**
 * LanguageToggle component for switching between Italian and English
 */
const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <Tooltip title={language === 'it' ? 'Switch to English' : 'Passa all\'Italiano'}>
      <IconButton
        onClick={toggleLanguage}
        sx={{
          color: 'primary.contrastText',
          fontWeight: 'bold',
          fontSize: '1rem',
          '&:hover': {
            bgcolor: 'rgba(255, 255, 255, 0.1)',
          },
        }}
        aria-label="toggle language"
      >
        {language === 'it' ? 'EN' : 'IT'}
      </IconButton>
    </Tooltip>
  );
};

export default LanguageToggle;
